function fetchAwardDetailsQuery (id) {
  let variables = { id }

  return {
    operationName: 'fetchAwardDetailsQuery',
    query: `
      query fetchAwardDetailsQuery($id: Int!) {
        preis: award(id: $id) {
          _entityName
          _id: id
          _stringRep
          hatPreisgeld: endowed
          namePreis: name
          vergebenDurch: awardedBy
          verleihungsJahr: year
          organisationseinheit: organisationalUnit {
            _entityName
            _stringRep
            _id:id
            parentOrgaName
          }
          preisBezeichnung: type {
            _entityName
            _stringRep
          }
          preisTraeger: awardee {
            _entityName
            _stringRep: fullName
            fisPersid
            orcid
          }
        }
      }
    `,
    variables
  }
}

export { fetchAwardDetailsQuery }



// WEBPACK FOOTER //
// ./src/graphql/awardDetails.js